import { AssigneeType, PostStatusPropertyValue, PropertyValue } from 'api/clients/PropertyClient'
import { Tag } from 'common/OptionSelect/Tag'
import { usePostProperties } from 'components/ArticlePostPreview/usePostProperties'
import { useScheduledPost } from 'hooks/queries/scheduledPosts/useScheduledPost'

interface Props {
  scheduledPostId?: number
  articleId: string
  size?: 'md' | 'sm'
  overrides?: Partial<Record<PostStatusPropertyValue, string>>
}

export const ScheduledPostStatusTag = ({ scheduledPostId, articleId, size, overrides }: Props) => {
  const { data: scheduledPost } = useScheduledPost({ id: scheduledPostId })
  const { status } = usePostProperties({ id: articleId, type: AssigneeType.Article })
  const statusColor = (status as PropertyValue)?.meta?.color as string

  const postStatus = scheduledPost?.is_posting ? { value: 'Posting...' } : status
  const postStatusColor = scheduledPost?.is_posting ? '#ffefc5' : statusColor

  if (!postStatus || !postStatusColor) return null

  return (
    <Tag size={size} color={postStatusColor}>
      {overrides?.[postStatus?.value as PostStatusPropertyValue] || postStatus?.value}
    </Tag>
  )
}
